import { OptionProps, components } from "react-select";

import styles from "./select-layout.module.scss";

type OptionType = {
  value: string;
  label: string;
};

const Option = (props: OptionProps) => (
  <components.Option
    {...props}
    innerProps={{ ...props.innerProps, id: styles.option }}
  >
    <div title={(props.data as OptionType).label}>
      {(props.data as OptionType).label}
    </div>
  </components.Option>
);

export default Option;
